<template>
    <va-create-layout>
        <ShipmentEventOrderCharge-form
            :title="title"
            :item="item"
        ></ShipmentEventOrderCharge-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
